import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Admin-only. Reveals the team's historical customers — one paid lookup per
 * unrevealed person — so the caller must bound the scope and the spend.
 */
export const startRecognizeBackfill = unaryRpc({
  name: "startRecognizeBackfill",
  input: z
    .object({
      teamId: zExt.objectId(),
      lookbackDays: z.number().int().positive().max(3650).optional(),
      maxOrders: z.number().int().positive().max(100_000).optional(),
      maxCustomers: z.number().int().positive().max(5000),
    })
    .refine(
      (value) => value.lookbackDays != null || value.maxOrders != null,
      "Provide a lookback window or an order count",
    ),
  output: z.object({
    started: z.boolean(),
    workflowId: z.string().nullable(),
    message: z.string().optional(),
  }),
});

export const getRecognizeBackfillStatus = unaryRpc({
  name: "getRecognizeBackfillStatus",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    workflowId: z.string().nullable(),
    running: z.boolean(),
    result: z
      .object({
        ordersScanned: z.number(),
        customersFound: z.number(),
        alreadyFresh: z.number(),
        attempted: z.number(),
        revealed: z.number(),
        failed: z.number(),
        cappedByMaxCustomers: z.boolean(),
      })
      .nullable(),
  }),
});

/**
 * Admin-only. Re-answers criteria for shoppers already revealed, reusing the
 * stored profile — LLM calls only, no paid lookups.
 */
export const startRecognizeReclassify = unaryRpc({
  name: "startRecognizeReclassify",
  input: z.object({
    teamId: zExt.objectId(),
    maxProfiles: z.number().int().positive().max(5000),
  }),
  output: z.object({
    started: z.boolean(),
    workflowId: z.string().nullable(),
    message: z.string().optional(),
  }),
});
